import React, { useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import AdminDashboard from '../components/AdminDashboard';
import UserManagement from '../components/UserManagement';
import ContentManagement from '../components/ContentManagement';
import AdminDailyLivingPage from '../components/AdminDailyLivingPage';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import FeatureFlags from '../components/FeatureFlags';
import { useUser } from '../context/UserContext';
import './AdminPage.css';

const AdminPage = () => {
  const { logout } = useUser();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'users':
        return <UserManagement />;
      case 'content':
        return <ContentManagement />;
      case 'daily-living-admin':
        return <AdminDailyLivingPage />;
      case 'reports':
        return <AnalyticsDashboard />;
      case 'features':
        return <FeatureFlags />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="admin-page">
      <Header isLoggedIn={true} onLogout={logout} isAdmin={true} onToggleSidebar={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)} />
      
      <div className="admin-layout">
        <Sidebar
          isAdmin={true}
          activeItem={activeSection}
          onItemClick={setActiveSection}
          isMobileOpen={isMobileSidebarOpen}
          onCloseMobile={() => setIsMobileSidebarOpen(false)}
        />
        
        <main className="admin-main-content">
          {renderSection()}
        </main>
      </div>
    </div>
  );
};

export default AdminPage;